<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-col xl="5" lg="7" md="8" sm="10" cols="12">
            <v-form @submit.prevent="$refs.form?.isValid ? submit() : ''" ref="form">
                <switch-input v-model="form.status" label="وضعیت"></switch-input>
                <v-text-field
                    :rules="$validation('required')"
                    label="* عنوان"
                    v-model="form.name"
                ></v-text-field>
                <v-autocomplete
                    :rules="$validation('required')"
                    label="* دپارتمان مرتبط"
                    no-data-text="موردی پیدا نشد!"
                    item-title="name"
                    item-value="id"
                    :items="departments"
                    v-model="form.department_id"
                ></v-autocomplete>
                <v-textarea
                    :rules="$validation()"
                    no-resize
                    rows="3"
                    label="توضیحات برای نمایش در فرم ثبت تیکت"
                    v-model="form.description"
                ></v-textarea>
                <div v-if="$system.license.features.kb_core">
                    <custom-divider label="مقاله های مرتبط پایگاه دانش"></custom-divider>
                    <p class="text-grey-darken-1 mb-3 text-small">مرتبط ترین مقاله های پایگاه دانش برای این دسته بندی را انتخاب کنید تا در زمان ثبت تیکت به کاربران پیشنهاد شوند.</p>
                    <v-autocomplete
                        :items="articleItems"
                        hide-no-data
                        placeholder="حداقل 3 حرف جستجو کنید"
                        @update:modelValue="articleInputChange"
                        @update:search="articleInputSearchChange"
                        item-title="name"
                        item-value="id"
                        label="جستجو مقاله"
                    ></v-autocomplete>
                    <v-fade-transition>
                        <v-row v-for="item in articles" :key="item.id" class="bg-grey-lighten-4 mb-4 mx-0 rounded" style="border: 1px solid #E6E6E6 !important" align="center">
                            <v-col class="pe-0" cols="auto"><v-icon size="20">icon-kb</v-icon></v-col>
                            <v-col><p class="text-grey-darken-1 mb-0 text-meta">{{ item.name }}</p></v-col>
                            <v-col cols="auto" class="py-0"><v-btn icon="icon-trash" variant="text" @click="removeArticle(item.id)"></v-btn></v-col>
                        </v-row>
                    </v-fade-transition>
                </div>
                <div class="mt-4">
                    <v-btn color="success" type="submit" :loading="loading">ثبت اطلاعات</v-btn>
                    <v-btn color="error" variant="text" class="ms-3" @click="$router.push({path: '/settings/ticketCategory'})" :disabled="loading">بازگشت</v-btn>
                </div>
            </v-form>
        </v-col>
    </div>
</template>
<script>
export default {
    title: "ایجاد",
    validate(context) {
      return context.auth.user.full_admin;
    },
    data() {
        return {
            loading: false,
            departments: [],
            articles: [],
            articleList: [],
            form: {
                status: true,
                department_id: null,
                name: null,
                description: null,
            },
        };
    },
    computed: {
        articleItems() {
            return this.articleList.filter(x => !this.articles.find(y => y.id == x.id));
        }
    },
    methods: {
        articleInputSearchChange(val) {
            if (val && val.length > 2) {
                this.$knowledgebaseArticleList({name: `${val}`}).then((res) => {
                    if (res && res.status == "OK")
                        this.articleList = res.data;
                });
            }
        },
        removeArticle(id) {
            this.articles = this.articles.filter(x => x.id != id);
        },
        articleInputChange(val) {
            this.articles.push(this.articleList.find(x => x.id == val));
        },
        submit() {
            this.loading = true;
            let form = {...this.form};
            if(this.$system.license.features.kb_core)
                form.articles = this.articles.length ? this.articles.map(x => x.id) : [];
            else
                delete form.articles;
            this.$ticketCategoryStore(form).then((res) => {
                if (res && res.status == "CREATED") {
                    this.$toast.success(res.message);
                    this.$system.setSystemDefaults(true);
                    this.$router.push({path: '/settings/ticketCategory'});
                }
            }).finally(()=>{this.loading = false});
        },
    },
    mounted() {
        this.departments = this.$system.departments;
    },
};
</script>
